import { BadgeType, } from '@tribeplatform/gql-client/types';
import { useCachedNetwork } from '@tribeplatform/react-sdk/hooks';
import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokenKey, getMemberKey, getNetworkKey } from '../../utils/keys';
export const useAssignBadge = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const network = useCachedNetwork();
    return useMutation(input => client.badge.assign(input), {
        onMutate: variables => {
            var _a, _b;
            const memberKey = getMemberKey({
                variables: { id: (_a = variables === null || variables === void 0 ? void 0 : variables.input) === null || _a === void 0 ? void 0 : _a.memberId },
            });
            queryClient.cancelQueries(memberKey);
            const badge = (_b = network === null || network === void 0 ? void 0 : network.badges) === null || _b === void 0 ? void 0 : _b.find(badge => (badge === null || badge === void 0 ? void 0 : badge.id) === (variables === null || variables === void 0 ? void 0 : variables.id));
            queryClient.setQueriesData(memberKey, old => {
                var _a;
                return ({
                    ...old,
                    badges: [
                        ...((_a = old === null || old === void 0 ? void 0 : old.badges) !== null && _a !== void 0 ? _a : []),
                        {
                            badge,
                            badgeId: badge === null || badge === void 0 ? void 0 : badge.id,
                            type: BadgeType.Manual,
                            shortDescription: badge === null || badge === void 0 ? void 0 : badge.shortDescription,
                        },
                    ],
                });
            });
        },
        onSettled: (data, error, variables) => {
            var _a;
            const memberKey = getMemberKey({
                variables: { id: (_a = variables === null || variables === void 0 ? void 0 : variables.input) === null || _a === void 0 ? void 0 : _a.memberId },
            });
            const networkKey = getNetworkKey();
            const authTokenKey = getAuthTokenKey();
            queryClient.invalidateQueries(memberKey);
            queryClient.invalidateQueries(authTokenKey);
            queryClient.invalidateQueries(networkKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useAssignBadge.js.map